import React, { useState, useEffect, useContext, useMemo } from "react";
import { Box, Typography } from "@material-ui/core";
import {
  ContactInfoWorkflow,
  IContactInfo,
  TravelerSelectStep,
  ContactInfoStep,
  Header,
  MobilePopoverCard,
  BackButton,
  MobileFloatingButton,
  LoadingPopup,
  B2BSpinner,
  emailRegex,
  phoneRegex,
  Icon,
  IconName,
  InformationalModal as TreesModal,
  PolicyPill,
  ApprovalReasonWorkflow,
  ApprovalBanner,
  ApprovalReasonStep,
  TravelWalletSingleSelectionStep,
  VoidWindowNotice,
  TripPurposePanel,
  TripDescription,
  CorpRewardsEarnBanner,
  FunnelType,
  MobileBusinessLoyaltyWorkflow,
  useAaBusinessLoyaltyGate,
} from "halifax";
import "./styles.scss";
import { RouteComponentProps } from "react-router";
import {
  PriceDropProtectionEnum,
  PriceDropViewedProperties,
  PRICE_DROP_VIEWED,
  VIEWED_PRICE_DROP_DETAILS,
  ADD_CONTACT_INFO,
  FlightShopStep,
  FlightBookType,
  TripCategory,
  ProductFeedLoadingProperties,
  PRODUCT_FEED_LOADING,
  CorpSessionInfo,
} from "redmond";
import clsx from "clsx";
import { useSelector } from "react-redux";
import {
  useBusinessExperimentsById,
  useExperimentIsVariant,
} from "@capone/experiments";
import {
  CDN_ASSETS,
  useShowPolicyBanner,
  VXB,
  isCorpTenant,
  getCurrentCorpAccount,
  getConfigTenant,
  getIsEMEligible,
  isVesperTenant,
  checkIsFreeFdaEnabled,
} from "@capone/common";
import { FlightShopSummaryPanel } from "../../../../shop/components/FlightShopSummaryPanel";
import { CorpMobileFlightBookWorkflowConnectorProps } from "./container";
import {
  PriceBreakdown,
  FlightBookPassengerSelection,
  PaymentCard,
  FlightBookMobileButton,
  PriceBreakdownDropdown,
  MobileSeatSelection,
  PriceDropProtection,
  PriceDropFOCreditBanner,
  AGENT_FEE,
} from "../..";
import {
  CONTACT_INFO_SAVE,
  CONTINUE,
  CONTACT_INFO_TITLE,
  CONTACT_INFO_SUBTITLE,
  REVIEW_MY_TRIP_TEXT,
  TITLE,
  SUBTITLE,
  PRICE_QUOTE_PASSENGER_VALIDATION_MESSAGE,
  SEAT_SELECTION_TITLE,
  PRICE_QUOTE_MESSAGE,
  CHECKOUT_PRICE_BREAKDOWN_HEADER,
  UPDATE_TRAVELERS,
  EDIT_TRAVELERS,
  TREES_MODAL_CTA_TEXT,
  TREES_MODAL_HEADER,
  TREES_MODAL_SUBTITLE,
  TREES_MODAL_TITLE,
  TREES_BOLDED_MODAL_CTA_TEXT,
} from "../../capone/MobileFlightBookWorkflow/textConstants";
import {
  PATH_BOOK,
  PATH_BOOK_CONFIRMATION,
} from "../../../../../utils/urlPaths";
import { ClientContext } from "../../../../../App";
import { trackEvent } from "../../../../../api/v0/analytics/trackEvent";
import { SeatSelectionStep } from "../../MobileSeatSelection";
import {
  AVAILABLE,
  SEAT_SELECTION,
  getExperimentVariant,
  useExperiments,
  TREES_MODAL_EXPERIMENT,
  TRAVEL_WALLET_OFFER_EXPERIMENT,
  SEATS_UX_OPTIMIZATION,
  CREDIT_OFFER_STACKING_V1,
  PASSPORT_ENHANCEMENT,
  TRAVEL_CREDIT_HISTORY_EXPERIMENT,
  TRAVEL_WALLET_CREDITS_EXPERIMENT,
  VOID_WINDOW_EXPERIMENT,
  CHECKOUT_REWARDS_EARN_BANNER_EXPERIMENT,
} from "../../../../../context/experiments";
import { fetchCustomerDetails } from "../../../../../api/v0/customer/fetchCustomerDetails";
import { usePrevious } from "../../../../../hooks/usePrevious";
import { MobileFlightBookWorkflowStep } from "../../../component";
import { TravelOfferSelection } from "../../TravelOfferSelection";
import { FlightAdditionalInfoWorkflow } from "../FlightAdditionalInfoWorkflow";
import { getFrequentFlyerProgramFromTrip } from "../FlightTravelerSelectDropdownForm/utils";
import { getPriceDropRefundTypeSelector } from "../../../../ancillary/reducer";
import {
  IVirtualInterliningVariant,
  VirtualInterliningModal,
} from "../../../../shop/components/VirtualIinterliningModal";
import { MulticityFlightShopStep } from "../../../../shop/reducer";
import { MultipleAirlinesFareModal } from "../../../../shop/components/MultipleAirlinesFareModal";
import { config } from "../../../../../api/config";

export interface ICorpMobileFlightBookWorkflowProps
  extends RouteComponentProps,
    CorpMobileFlightBookWorkflowConnectorProps {
  checkoutStep: MobileFlightBookWorkflowStep;
  setCheckoutStep: (step: any) => void;
  localTravelerIds: string[];
  setLocalTravelerIds: (ids: string[]) => void;
  localLapInfantIds: string[];
  setLocalLapInfantIds: (ids: string[]) => void;
}

export const CorpMobileFlightBookWorkflow = ({
  isWaitingValidation,
  selectedTrip,
  hasNoUserPassengers,
  history,
  finalizedItinerary,
  isBookingValid,
  scheduleQuote,
  setContactInfo,
  confirmationEmail,
  confirmationPhoneNumber,
  priceDropProtection,
  isFareOptimizationCreditShopTime,
  priceDropViewedProperties,
  populateFlightShopQueryParams,
  priceQuote,
  schedulePayment,
  currentSession,
  payments,
  ancillaries,
  seatMapAvailability,
  isWaitingPriceQuote,
  seatMapLoading,
  resetPaymentCardSelectedAccounts,
  hasError,
  errorTitles,
  setFlightShopProgress,
  missingPassport,
  checkoutStep,
  setCheckoutStep,
  flightBookType,
  offers,
  localLapInfantIds,
  setLocalLapInfantIds,
  localTravelerIds,
  setLocalTravelerIds,
  corporateTravel,
  tripDetails,
  disruptionDelayThreshold,
  tripCategory,
  fetchApplicableTravelWalletItems,
  credit,
  fetchInitialCrossSellHotelAvailability,
  airports,
  isVoidWindowEligible,
  isTravelWalletPaymentOnly,
  priceQuoteInProgress,
  creditToApply,
  fetchTravelWalletCreditHistory,
  hasSelectedDisruption,
  smsBeenSelected,
  appNotifBeenSelected,
  toggleAppNotifOptIn,
  toggleSMSOptIn,
  disruptionOptInEnabled,
  tcpaConsentPhoneNumber,
  setUserTcpaConsentPhoneNumber,
  isInternationalFlight,
  setMulticityFlightShopProgress,
  setTripPurpose,
  setTripDescription,
  largestValueAccount,
  calculatedEarn,
  fetchCorpUserPassengers,
  updateUserPassenger,
  userPassengers,
  userSelectedPassengerIds,
  fdaProductVariant,
}: ICorpMobileFlightBookWorkflowProps) => {
  const clientContext = useContext(ClientContext);
  const isVesper = isVesperTenant(getConfigTenant());
  const { sessionInfo, isAgentPortal, isAutoApprovalEnabled, policies } =
    clientContext;

  const rewardsAccounts = useSelector(
    (state: any) => state.flightRewards.rewardsAccounts,
  );
  const accountForBanner = useMemo(() => {
    if (isCorpTenant(config.TENANT)) {
      const corpAccount = getCurrentCorpAccount(rewardsAccounts, sessionInfo);
      return corpAccount || largestValueAccount;
    }
    return largestValueAccount;
  }, [rewardsAccounts, sessionInfo, largestValueAccount, config.TENANT]);
  const isEMEligible = getIsEMEligible(accountForBanner);

  // NFU user detection - NFU users don't have the app, so hide push notifications
  // but keep SMS notifications by using the updated alert opt-in UI
  const isNonFinancialUser =
    (sessionInfo as CorpSessionInfo)?.corporateInfo?.cap1Role === "NFU";

  const isInPolicyCheckout = corporateTravel?.policyCompliance.isInPolicy ?? true;

  const expState = useExperiments();
  const seatSelectionGroup = getExperimentVariant(
    expState.experiments,
    SEAT_SELECTION,
  );
  const treesModalExperiment = getExperimentVariant(
    expState.experiments,
    TREES_MODAL_EXPERIMENT,
  );

  const isSeatSelection = useMemo(
    () =>
      seatSelectionGroup === AVAILABLE &&
      (isInPolicyCheckout || Boolean(isAutoApprovalEnabled)),
    [seatSelectionGroup, isInPolicyCheckout],
  );

  const isTreesModalExperiment = useMemo(
    () => treesModalExperiment === AVAILABLE,
    [treesModalExperiment],
  );

  const travelWalletOffer = getExperimentVariant(
    expState.experiments,
    TRAVEL_WALLET_OFFER_EXPERIMENT,
  );
  const isTravelWalletOfferExperiment = React.useMemo(
    () => travelWalletOffer === AVAILABLE,
    [travelWalletOffer],
  );

  const travelWalletCreditsExperiment = getExperimentVariant(
    expState.experiments,
    TRAVEL_WALLET_CREDITS_EXPERIMENT,
  );
  const isTravelWalletCreditsExperiment = React.useMemo(
    () => travelWalletCreditsExperiment === AVAILABLE,
    [travelWalletCreditsExperiment],
  );

  const creditAndOfferStackingExperimentV1 = getExperimentVariant(
    expState.experiments,
    CREDIT_OFFER_STACKING_V1,
  );
  const isCreditAndOfferStackingExperimentV1 = useMemo(
    () => creditAndOfferStackingExperimentV1 === AVAILABLE,
    [creditAndOfferStackingExperimentV1],
  );

  const travelCreditHistoryExperiment = getExperimentVariant(
    expState.experiments,
    TRAVEL_CREDIT_HISTORY_EXPERIMENT,
  );
  const isTravelCreditHistoryExperiment = useMemo(
    () => travelCreditHistoryExperiment === AVAILABLE,
    [travelCreditHistoryExperiment],
  );

  const freeFdaVariant = useBusinessExperimentsById("corp-free-fda")?.variant;
  const isFreeFdaExperimentEnabled =
    freeFdaVariant === "available" || freeFdaVariant === "available_phase2";
  const isFreeFdaActive = checkIsFreeFdaEnabled({
    isFreeFdaExperimentEnabled,
    productVariant: fdaProductVariant,
  });

  const isVoidWindowExperiment = useMemo(
    () =>
      getExperimentVariant(expState.experiments, VOID_WINDOW_EXPERIMENT) ===
      AVAILABLE,
    [expState],
  );

  const isSeatsUXOptimizationExperiment = useMemo(
    () =>
      getExperimentVariant(expState.experiments, SEATS_UX_OPTIMIZATION) ===
      AVAILABLE,
    [expState],
  );

  const isTripPurposeXpEnabled = useExperimentIsVariant(
    "corp-trip-purpose",
    AVAILABLE,
  );

  const isExpenseManagementExperiment = useExperimentIsVariant(
    "corp-expense-management",
    AVAILABLE
  );

  const isCheckoutRewardsEarnBannerExperiment = useExperimentIsVariant(
    CHECKOUT_REWARDS_EARN_BANNER_EXPERIMENT,
    AVAILABLE,
  );

  const isGlobalMobileNavExperiment = useExperimentIsVariant(
    "c1-marketplace-global-mobile-nav",
    AVAILABLE,
  );

  const hideSmsOptIn = useExperimentIsVariant(
    "hide-disruption-sms-notifications",
    AVAILABLE
  );
  const hideAppNotificationOptIn = useExperimentIsVariant(
    "hide-disruption-app-notifications",
    AVAILABLE
  );

  const {
    isFlagEnabled: isBusinessLoyaltyRefreshEnabled,
    isAdmin,
    hasAaSegment,
    businessId,
  } = useAaBusinessLoyaltyGate(tripDetails, sessionInfo);
  const isLoyaltyStepEligible = Boolean(
    isBusinessLoyaltyRefreshEnabled && isAdmin && hasAaSegment && businessId
  );

  // Virtual Interline Flights will offer only one type of fare the most basic is safe to only check the first index
  const isVITripSelected = tripDetails.fareDetails[0]?.slices.some((slice) =>
    slice.fareDetails.segments.some((segment) => segment.isSelfTransferLayover),
  );

  // Follows patterns established elsewhere, but the flag is not (yet) needed in this context.
  const [openVIVariantModal, setOpenVIVariantModal] = useState<
    IVirtualInterliningVariant | "reminder" | false
  >(false);

  // Follows patterns established elsewhere, but the flag is not (yet) needed in this context.
  const [openMultipleAirlinesFares, setOpenMultipleAirlinesFares] =
    useState(false);

  const passportEnhancementExperiment = getExperimentVariant(
    expState.experiments,
    PASSPORT_ENHANCEMENT,
  );
  const isPassportEnhancementExperiment = useMemo(
    () => passportEnhancementExperiment === AVAILABLE,
    [passportEnhancementExperiment],
  );

  const priceDropRefundType = useSelector(getPriceDropRefundTypeSelector);

  // TODO: remove this when we decide if using text message - https://hopchat.slack.com/archives/C01FX0M22MV/p1620146159000600
  const [contactInfo, setContact] = useState<IContactInfo | null>({
    phoneNumber: confirmationPhoneNumber || "",
    email: confirmationEmail || sessionInfo?.userInfo?.email || "",
  });
  const [customerDetailsLoading, setCustomerDetailsLoading] =
    React.useState<boolean>(true);

  const [travelerWorkflowStep, setTravelerWorkflowStep] =
    useState<TravelerSelectStep>(TravelerSelectStep.Main);
  const [contactInfoStep, setContactInfoStep] = useState<ContactInfoStep>(
    ContactInfoStep.Main,
  );
  const [seatSelectionStep, setSeatSelectionStep] = useState<SeatSelectionStep>(
    SeatSelectionStep.Main,
  );
  const [travelWalletSelectStep, setTravelWalletSelectStep] =
    useState<TravelWalletSingleSelectionStep>(
      TravelWalletSingleSelectionStep.Main,
    );
  const [approvalReasonStep, setApprovalReasonStep] =
    useState<ApprovalReasonStep>(ApprovalReasonStep.Main);
  const [openPaymentCard, setOpenPaymentCard] = useState<boolean>(false);
  const [treeModalOpen, setTreeModalOpen] = useState(false);
  const [updatedInfoOnReview, setUpdatedInfoOnReview] = useState(false);
  const [isAdditionalInfoCardOpen, setIsAdditionalInfoCardOpen] =
    useState<boolean>(false);
  const [selectedTravelerIndex, setSelectedTravelerIndex] = useState<number>(0);

  const frequentFlyerPrograms = useMemo(
    () => getFrequentFlyerProgramFromTrip(tripDetails),
    [tripDetails],
  );

  const selectedTravelers = useMemo(
    () => userPassengers.filter((p) => userSelectedPassengerIds.includes(p.id)),
    [userPassengers, userSelectedPassengerIds],
  );

  const isLoyaltyEligible =
    frequentFlyerPrograms !== null && frequentFlyerPrograms.length > 0;

  const isMulticity: boolean = tripCategory === TripCategory.MULTI_CITY;

  const disruptionDelayThresholdStringInHours =
    disruptionDelayThreshold === 180 ? "3" : "2";

  const [approvalRequestReason, setApprovalRequestReason] = useState<
    string | undefined
  >();

  useEffect(() => {
    if (isMulticity) {
      // Multi-city tracks flight shop progress a little differently. Book is a step in itself.
      setMulticityFlightShopProgress(MulticityFlightShopStep.BookTrip);
    }
  }, []);

  const isPDPEligible =
    priceDropProtection &&
    priceDropProtection.PriceDropProtection ===
      PriceDropProtectionEnum.IsEligible;

  const onBookFlight = () => {
    if (selectedTrip.tripId) {
      priceQuote && currentSession && payments && ancillaries
        ? schedulePayment({
            session: currentSession,
            payments,
            ancillaries,
            agentFee: isAgentPortal ? AGENT_FEE : 0,
            approvalRequestReason,
          })
        : scheduleQuote({ agentFee: isAgentPortal ? AGENT_FEE : 0 });
    }
  };

  const openFlightBookPassengerSelection = () =>
    setTravelerWorkflowStep(TravelerSelectStep.TravelerSelect);

  const openContactInfoWorkflow = () => {
    setContactInfoStep(ContactInfoStep.ContactInfoForm);
  };

  const openSeatSelectionWorkflow = () => {
    setSeatSelectionStep(SeatSelectionStep.SeatSelection);
  };

  const openTravelOffersSelection = () => {
    setTravelWalletSelectStep(
      TravelWalletSingleSelectionStep.TravelWalletSelection,
    );
  };

  const openApprovalReasonWorkflow = () => {
    setApprovalReasonStep(ApprovalReasonStep.ApprovalReason);
  };

  const openAdditionalInfoWorkflow = () => {
    setIsAdditionalInfoCardOpen(true);
  };

  const openPaymentSelection = () => setOpenPaymentCard(true);

  const computeAfterContactInfoStep = () => {
    if (!isSeatSelection || !seatMapAvailability || !isInPolicyCheckout) {
      if (
        !isCreditAndOfferStackingExperimentV1 &&
        ((isTravelWalletCreditsExperiment ? !!credit : false) ||
          (isTravelWalletOfferExperiment ? !!offers?.length : false))
      ) {
        return MobileFlightBookWorkflowStep.TravelOfferSelection;
      }
      return MobileFlightBookWorkflowStep.RewardsAndPayment;
    }
    return MobileFlightBookWorkflowStep.SeatSelection;
  };

  const incrementCheckoutStep = () => {
    setCheckoutStep((step: any) => {
      switch (step) {
        case MobileFlightBookWorkflowStep.TravelerInformation:
          return step + 2;
        case MobileFlightBookWorkflowStep.Review:
          return step;
        case MobileFlightBookWorkflowStep.AdditionalInformation:
          return step + 1;
        case MobileFlightBookWorkflowStep.ContactInformation:
          if (isLoyaltyStepEligible) {
            return MobileFlightBookWorkflowStep.BusinessLoyaltyProgram;
          }
          return computeAfterContactInfoStep();
        case MobileFlightBookWorkflowStep.BusinessLoyaltyProgram:
          return computeAfterContactInfoStep();

        case MobileFlightBookWorkflowStep.SeatSelection:
          if (isTravelWalletOfferExperiment && (offers?.length || 0) > 0) {
            return step + 1;
          }
          return step + 2;
        case MobileFlightBookWorkflowStep.RewardsAndPayment:
          return isInPolicyCheckout ? step + 2 : step + 1; // skips approval reason step
        default:
          return step + 1;
      }
    });
  };

  const handleGoBack = () => {
    switch (checkoutStep) {
      case MobileFlightBookWorkflowStep.TravelerInformation:
        switch (flightBookType) {
          case FlightBookType.DEFAULT:
          default:
            populateFlightShopQueryParams({
              history,
              prevPath: PATH_BOOK,
              useHistoryPush: true,
              newQueryParams: {
                flightShopProgress: FlightShopStep.ChooseDeparture,
              },
            });
            setFlightShopProgress(FlightShopStep.ChooseDeparture);
            break;
        }
        break;
      case MobileFlightBookWorkflowStep.AdditionalInformation:
        setCheckoutStep(MobileFlightBookWorkflowStep.TravelerInformation);
        break;
      case MobileFlightBookWorkflowStep.ContactInformation:
        // note: skip PricingAndPassengerValidation step when going back from ContactInformation
        setCheckoutStep(MobileFlightBookWorkflowStep.AdditionalInformation);
        break;
      case MobileFlightBookWorkflowStep.SeatSelection:
        // note: skip PricingAndPassengerValidation step when going back from ContactInformation
        setCheckoutStep(
          isLoyaltyStepEligible
            ? MobileFlightBookWorkflowStep.BusinessLoyaltyProgram
            : MobileFlightBookWorkflowStep.ContactInformation
        );
        break;
      case MobileFlightBookWorkflowStep.BusinessLoyaltyProgram:
        setCheckoutStep(MobileFlightBookWorkflowStep.ContactInformation);
        break;
      case MobileFlightBookWorkflowStep.TravelOfferSelection:
        if (!isSeatSelection || !seatMapAvailability) {
          setCheckoutStep(
            isLoyaltyStepEligible
              ? MobileFlightBookWorkflowStep.BusinessLoyaltyProgram
              : MobileFlightBookWorkflowStep.ContactInformation
          );
        } else {
          setCheckoutStep((step: any) => step - 1);
        }
        break;
      case MobileFlightBookWorkflowStep.RewardsAndPayment:
        if (isTravelWalletOfferExperiment && (offers?.length || 0) > 0) {
          setCheckoutStep(MobileFlightBookWorkflowStep.TravelOfferSelection);
        } else if (
          isSeatSelection &&
          seatMapAvailability &&
          isInPolicyCheckout
        ) {
          setCheckoutStep(MobileFlightBookWorkflowStep.SeatSelection);
        } else {
          setCheckoutStep(MobileFlightBookWorkflowStep.ContactInformation);
        }
        break;
      default:
        setCheckoutStep((step: any) => step - 1);
        break;
    }
  };

  const closeAllPopovers = () => {
    setTravelerWorkflowStep(TravelerSelectStep.Main);
    setContactInfoStep(ContactInfoStep.Main);
    setIsAdditionalInfoCardOpen(false);
    if (isSeatSelection) {
      setSeatSelectionStep(SeatSelectionStep.Main);
    }
    setTravelWalletSelectStep(TravelWalletSingleSelectionStep.Main);
    setApprovalReasonStep(ApprovalReasonStep.Main);
    setOpenPaymentCard(false);
  };

  const handlePriceDropTracking = () =>
    trackEvent({
      eventName: VIEWED_PRICE_DROP_DETAILS,
      properties: {
        page:
          checkoutStep === MobileFlightBookWorkflowStep.Review
            ? "trip_review"
            : "payment_summary",
        refund_type: priceDropRefundType,
      },
    });

  const startSchedulePriceQuoteAndResetPayment = () => {
    scheduleQuote({
      agentFee: isAgentPortal ? AGENT_FEE : 0,
      pollQuoteOnly: true,
    });
    // note: reset selected rewards account and payment method ids
    resetPaymentCardSelectedAccounts();
    setUpdatedInfoOnReview(true);
  };

  const renderPriceBreakdownDropdown = (priceBreakdownDropdownProps?: {
    popoverClassName?: string;
    dataTestIds?: {
      popover?: string;
      trigger?: string;
    };
  }) => (
    <PriceBreakdownDropdown
      handlePriceDropTracking={handlePriceDropTracking}
      popoverClassName={priceBreakdownDropdownProps?.popoverClassName}
      dataTestIds={priceBreakdownDropdownProps?.dataTestIds}
    />
  );

  useEffect(() => {
    switch (checkoutStep) {
      case MobileFlightBookWorkflowStep.TravelerInformation:
        closeAllPopovers();
        openFlightBookPassengerSelection();
        break;
      case MobileFlightBookWorkflowStep.AdditionalInformation:
        closeAllPopovers();
        openAdditionalInfoWorkflow();
        break;
      case MobileFlightBookWorkflowStep.ContactInformation:
        closeAllPopovers();
        openContactInfoWorkflow();
        break;
      case MobileFlightBookWorkflowStep.BusinessLoyaltyProgram:
        closeAllPopovers();
        break;
      case MobileFlightBookWorkflowStep.SeatSelection:
        closeAllPopovers();
        openSeatSelectionWorkflow();
        break;
      case MobileFlightBookWorkflowStep.TravelOfferSelection:
        closeAllPopovers();
        openTravelOffersSelection();
        break;
      case MobileFlightBookWorkflowStep.RewardsAndPayment:
        closeAllPopovers();
        openPaymentSelection();
        break;
      case MobileFlightBookWorkflowStep.ApprovalReason:
        closeAllPopovers();
        openApprovalReasonWorkflow();
        break;
      default:
        break;
    }
  }, [checkoutStep]);

  // note: it handles the PassengerSelection step logic separately from the previous useEffect;
  // when travelerWorkflowStep is being changed too rapidly (e.g.: changing from Main -> TravelerSelect -> TravelerInfoForm because of hasUserPassengers value)
  // it seems to cause some unexpected behaviours on TravelerSelectWorkflow, which in turn causes the Review screen to be unscrollable
  // https://hopper-jira.atlassian.net/browse/BP-1090
  useEffect(() => {
    if (
      checkoutStep === MobileFlightBookWorkflowStep.TravelerInformation &&
      hasNoUserPassengers
    ) {
      setTravelerWorkflowStep(TravelerSelectStep.TravelerInfoForm);
    }
  }, [checkoutStep, hasNoUserPassengers]);

  const prevMissingPassportError = usePrevious(missingPassport);
  useEffect(() => {
    if (
      hasError &&
      (errorTitles.primaryButtonText === UPDATE_TRAVELERS ||
        errorTitles.secondaryButtonText === EDIT_TRAVELERS) &&
      !missingPassport
    ) {
      setCheckoutStep(MobileFlightBookWorkflowStep.TravelerInformation);
    }
    if (prevMissingPassportError && !missingPassport) {
      if (!!priceQuoteInProgress && isPassportEnhancementExperiment) {
      } else {
        setCheckoutStep(MobileFlightBookWorkflowStep.TravelerInformation); // goes back selection AFTER passport info is updated from the missing passport info error
      }
    }
  }, [
    hasError,
    errorTitles,
    missingPassport,
    priceQuote,
    priceQuoteInProgress,
  ]);

  useEffect(() => {
    if (finalizedItinerary) {
      if (isPDPEligible) {
        const properties: PriceDropViewedProperties = {
          ...priceDropViewedProperties,
          page:
            checkoutStep === MobileFlightBookWorkflowStep.Review
              ? "trip_review"
              : "payment_summary",
        };
        trackEvent({
          eventName: PRICE_DROP_VIEWED,
          properties,
        });
      }

      const properties: ProductFeedLoadingProperties = {
        feed_type: "cross_sell_hotels",
        feed_placement: "flight_confirmation",
      };
      trackEvent({ eventName: PRODUCT_FEED_LOADING, properties });
      fetchInitialCrossSellHotelAvailability(finalizedItinerary, airports);

      history.push(PATH_BOOK_CONFIRMATION);
    }
  }, [finalizedItinerary]);

  useEffect(() => {
    fetchCorpUserPassengers();
  }, []);

  useEffect(() => {
    if (
      checkoutStep === MobileFlightBookWorkflowStep.Review &&
      !!priceQuote &&
      !priceQuoteInProgress &&
      updatedInfoOnReview
    ) {
      if (isSeatSelection && seatMapAvailability) {
        setCheckoutStep(MobileFlightBookWorkflowStep.SeatSelection); // if seats are avail after PQ is run again, bring user back to step to select seats
      } else if (creditToApply) {
        setCheckoutStep(MobileFlightBookWorkflowStep.TravelOfferSelection); // if user has selected a travel wallet item before PQ is run again on pax/contact info update, bring them back to that step
      } else {
        handleGoBack();
      }
      setUpdatedInfoOnReview(false);
    }
  }, [
    checkoutStep,
    priceQuote,
    priceQuoteInProgress,
    updatedInfoOnReview,
    seatMapAvailability,
  ]);

  useEffect(() => {
    isTravelWalletOfferExperiment && fetchApplicableTravelWalletItems();
    isTravelCreditHistoryExperiment && fetchTravelWalletCreditHistory();
    const getCustomerDetails = async () => {
      try {
        const details = await fetchCustomerDetails();
        setUserTcpaConsentPhoneNumber(details?.phoneNumber || "");
        setContact({
          email: "",
          ...contactInfo,
          phoneNumber: details?.phoneNumber || "",
        });
        setContactInfo(contactInfo?.email || "", details?.phoneNumber || "");
      } finally {
        setCustomerDetailsLoading(false);
      }
    };

    getCustomerDetails();
  }, []);

  useEffect(() => {
    if (
      checkoutStep === MobileFlightBookWorkflowStep.ContactInformation &&
      !!priceQuote
    ) {
      incrementCheckoutStep(); // Increment checkout step AFTER PQ comes back to see if user has seats or not to determine next checkout step
    }
  }, [priceQuote]);

  const showPolicyBanner = useShowPolicyBanner(policies, "flight");

  return (
    <>
      <Box
        className={clsx("corp-mobile-flight-book-workflow-root", {
          redesigned: isVesper,
          "mobile-review-flight-book":
            checkoutStep === MobileFlightBookWorkflowStep.Review,
          "global-mobile-nav": isGlobalMobileNavExperiment,
        })}
      >
        <Header
          className="mobile-flight-book-workflow-header checkout"
          left={
            <BackButton
              className="mobile-flight-book-header-go-back"
              onClick={handleGoBack}
            />
          }
          right={
            checkoutStep === MobileFlightBookWorkflowStep.Review
              ? renderPriceBreakdownDropdown({
                  popoverClassName: "mobile-review-flight-book-price-breakdown",
                })
              : renderPriceBreakdownDropdown()
          }
          isMobile
          fullWidth
        />
        {isVoidWindowExperiment && isVoidWindowEligible && <VoidWindowNotice />}
        <PriceDropFOCreditBanner />
        <Box className="title-summary-container">
          <Typography variant="h6" className="title">
            {TITLE}
          </Typography>
          <Typography variant="body1" className="subtitle">
            {SUBTITLE}
          </Typography>
          {showPolicyBanner ? (
            <PolicyPill isInPolicy={isInPolicyCheckout} />
          ) : null}
        </Box>
        {isCheckoutRewardsEarnBannerExperiment &&
          isCorpTenant(config.TENANT) &&
          accountForBanner?.productDisplayName?.includes(VXB) &&
          accountForBanner?.earn?.flightsMultiplier === 5 && (
            <Box className="rewards-earn-banner-container">
              <CorpRewardsEarnBanner
                earn={calculatedEarn}
                earnRewardsAccount={accountForBanner}
                funnelType={FunnelType.FLIGHT}
                className="mobile-rewards-earn-banner"
              />
            </Box>
          )}
        <FlightShopSummaryPanel
          showViewDetailsSection
          prevPath={PATH_BOOK}
          isSeatsUXOptimizationExperiment={isSeatsUXOptimizationExperiment}
          isVITripSelected={isVITripSelected}
          setOpenVIVariantModal={setOpenVIVariantModal}
          setOpenMultipleAirlinesFares={setOpenMultipleAirlinesFares}
        />
        <FlightBookPassengerSelection
          progress={travelerWorkflowStep}
          setProgress={setTravelerWorkflowStep}
          onGoBack={(travelersChanged) => {
            switch (checkoutStep) {
              case MobileFlightBookWorkflowStep.TravelerInformation:
                handleGoBack();
                break;
              case MobileFlightBookWorkflowStep.Review:
                // note: when the user changes passengers on the final step and then clicks the go-back button,
                // handle it as if the user clicked continue; this is to avoid tricky cases such as having deleted
                // a selected traveler from list -> requires selected travelers to be updated -> needs to re-schedule price quote
                if (travelersChanged) {
                  startSchedulePriceQuoteAndResetPayment();
                }
                break;
              default:
                break;
            }
          }}
          onContinue={(travelersChanged) => {
            switch (checkoutStep) {
              case MobileFlightBookWorkflowStep.Review:
                if (travelersChanged) {
                  startSchedulePriceQuoteAndResetPayment();
                }
                break;
              default:
                incrementCheckoutStep();
                break;
            }
          }}
          selectionScreenHeaderElement={renderPriceBreakdownDropdown({
            dataTestIds: {
              popover: "flights-passenger-selection-price-breakdown-dialog",
              trigger:
                "flights-passenger-selection-price-breakdown-dialog-trigger",
            },
          })}
          className="b2b"
          onReviewStep={checkoutStep === MobileFlightBookWorkflowStep.Review}
          isMobile
          useLocalIds
          localLapInfantIds={localLapInfantIds}
          setLocalLapInfantIds={setLocalLapInfantIds}
          localTravelerIds={localTravelerIds}
          setLocalTravelerIds={setLocalTravelerIds}
          showVoidWindowNotice={isVoidWindowExperiment && isVoidWindowEligible}
          showPassportAwareness={
            isPassportEnhancementExperiment && isInternationalFlight
          }
          hiddenTravelerIds={[]}
        />
        <ContactInfoWorkflow
          titles={{
            contactInfoTitle: CONTACT_INFO_TITLE,
            contactInfoSubtitle: CONTACT_INFO_SUBTITLE,
            buttonTitle:
              checkoutStep === MobileFlightBookWorkflowStep.Review
                ? CONTACT_INFO_SAVE
                : CONTINUE,
          }}
          isMobile
          progressStep={contactInfoStep}
          setProgressStep={setContactInfoStep}
          contactInfo={contactInfo}
          hasSelectedDisruption={hasSelectedDisruption}
          smsBeenSelected={smsBeenSelected}
          appNotifBeenSelected={appNotifBeenSelected}
          toggleAppNotifOptIn={toggleAppNotifOptIn}
          toggleSMSOptIn={toggleSMSOptIn}
          disruptionOptInEnabled={disruptionOptInEnabled && !isFreeFdaActive}
          tcpaConsentPhoneNumber={tcpaConsentPhoneNumber}
          useUpdatedAlertOptIn={isNonFinancialUser}
          hideSmsOptIn={hideSmsOptIn}
          hideAppNotificationOptIn={hideAppNotificationOptIn}
          onGoBack={() => {
            if (
              checkoutStep === MobileFlightBookWorkflowStep.ContactInformation
            ) {
              handleGoBack();
            }
          }}
          onContactInfoChange={(contactInfoUpdate) => {
            setContact(contactInfoUpdate);
            setContactInfo(
              contactInfoUpdate.email,
              contactInfoUpdate.phoneNumber,
            );
            if (
              contactInfoUpdate.email &&
              contactInfoUpdate.phoneNumber &&
              emailRegex.test(contactInfoUpdate.email) &&
              phoneRegex.test(contactInfoUpdate.phoneNumber)
            ) {
              trackEvent({
                eventName: ADD_CONTACT_INFO,
                properties: {},
              });
            }
            !isSeatSelection && !isLoyaltyStepEligible && incrementCheckoutStep();
          }}
          mobileHeaderElement={renderPriceBreakdownDropdown()}
          className="b2b"
          onContinueClick={() => {
            if (checkoutStep === MobileFlightBookWorkflowStep.Review) {
              startSchedulePriceQuoteAndResetPayment();
              return;
            }
            if (
              checkoutStep ===
                MobileFlightBookWorkflowStep.ContactInformation &&
              isLoyaltyStepEligible
            ) {
              incrementCheckoutStep();
              return;
            }
            scheduleQuote({
              agentFee: isAgentPortal ? AGENT_FEE : 0,
              pollQuoteOnly: true,
            });
          }}
          loading={customerDetailsLoading}
          bottomContent={
            isVoidWindowExperiment && isVoidWindowEligible ? (
              <VoidWindowNotice />
            ) : undefined
          }
          disruptionDelayThresholdStringInHours={
            disruptionDelayThresholdStringInHours
          }
        />
        {isLoyaltyStepEligible && (
          <MobileBusinessLoyaltyWorkflow
            open={
              checkoutStep ===
              MobileFlightBookWorkflowStep.BusinessLoyaltyProgram
            }
            tripDetails={tripDetails}
            sessionInfo={sessionInfo}
            onGoBack={handleGoBack}
            onPersistSuccess={() => {
              scheduleQuote({
                agentFee: isAgentPortal ? AGENT_FEE : 0,
                pollQuoteOnly: true,
              });
              incrementCheckoutStep();
            }}
            mobileHeaderElement={renderPriceBreakdownDropdown()}
            className="capone-corporate"
            trackEvent={trackEvent}
          />
        )}
        <FlightAdditionalInfoWorkflow
          open={isAdditionalInfoCardOpen}
          isLoyaltyEligible={isLoyaltyEligible}
          frequentFlyerPrograms={frequentFlyerPrograms}
          onClickContinue={(updatedTraveler) => {
            updateUserPassenger({ person: updatedTraveler });
            if (selectedTravelerIndex < selectedTravelers.length - 1) {
              setSelectedTravelerIndex(selectedTravelerIndex + 1);
            } else {
              setSelectedTravelerIndex(0);
              if (checkoutStep === MobileFlightBookWorkflowStep.Review) {
                startSchedulePriceQuoteAndResetPayment();
                setIsAdditionalInfoCardOpen(false);
                openPaymentSelection();
              } else {
                incrementCheckoutStep();
              }
            }
          }}
          onGoBack={() => {
            if (selectedTravelerIndex > 0) {
              setSelectedTravelerIndex(selectedTravelerIndex - 1);
            } else {
              handleGoBack();
            }
          }}
          mobileHeaderElement={renderPriceBreakdownDropdown()}
          className="capone-corporate"
          traveler={selectedTravelers[selectedTravelerIndex]}
          tripDetails={tripDetails}
          sessionInfo={sessionInfo}
        />
        {isSeatSelection && (
          <MobileSeatSelection
            title={SEAT_SELECTION_TITLE}
            progressStep={seatSelectionStep}
            setProgressStep={setSeatSelectionStep}
            mobileHeaderElement={renderPriceBreakdownDropdown()}
            onGoBack={() => {
              if (checkoutStep === MobileFlightBookWorkflowStep.SeatSelection) {
                handleGoBack();
              }
            }}
            onContinue={() => incrementCheckoutStep()}
          />
        )}
        {isTravelWalletOfferExperiment &&
          !isCreditAndOfferStackingExperimentV1 && (
            <TravelOfferSelection
              progressStep={travelWalletSelectStep}
              mobileHeaderElement={<PriceBreakdownDropdown />}
              isMobile
              onGoBack={() => {
                if (
                  checkoutStep ===
                  MobileFlightBookWorkflowStep.TravelOfferSelection
                ) {
                  handleGoBack();
                }
              }}
              onContinueClick={() => {
                incrementCheckoutStep();
                isTravelWalletPaymentOnly &&
                  setTravelWalletSelectStep(
                    TravelWalletSingleSelectionStep.Main,
                  );
              }}
            />
          )}
        <Box className="pricing-breakdown-header-wrapper">
          <Box className="pricing-breakdown-header-container">
            <Typography className="header" variant="h6">
              {CHECKOUT_PRICE_BREAKDOWN_HEADER}
            </Typography>
          </Box>
        </Box>
        {priceDropProtection &&
          isPDPEligible &&
          !isFareOptimizationCreditShopTime && (
          <PriceDropProtection
            priceDropProtection={priceDropProtection}
            onClick={handlePriceDropTracking}
          />
        )}
        <PriceBreakdown
          isMobile
          className={clsx({
            "less-padding": isTreesModalExperiment || isTripPurposeXpEnabled,
          })}
        />

        {isTreesModalExperiment && (
          <TreesModal
            image={CDN_ASSETS.capone.trees.confirmation}
            header={TREES_MODAL_HEADER}
            title={TREES_MODAL_TITLE}
            onClose={() => setTreeModalOpen(false)}
            subtitle={TREES_MODAL_SUBTITLE}
            icon={<Icon className="trees-icon" name={IconName.TreesIcon} />}
            openModal={treeModalOpen}
            setOpenModal={setTreeModalOpen}
            modalLinkCopy={TREES_MODAL_CTA_TEXT}
            modalButtonCopyStartIcon={
              <Icon className="trees-icon" name={IconName.TreesIcon} />
            }
            isMobile
            boldedModalLinkCopy={TREES_BOLDED_MODAL_CTA_TEXT}
          />
        )}
        {!isInPolicyCheckout && (
          <>
            <ApprovalReasonWorkflow
              buttonText="Review my trip"
              progressStep={approvalReasonStep}
              setProgressStep={setApprovalReasonStep}
              mobileHeaderElement={<PriceBreakdownDropdown />}
              onGoBack={handleGoBack}
              className="b2b approval-reason-workflow"
              onContinueClick={(reason) => {
                incrementCheckoutStep();
                setApprovalRequestReason(reason);
              }}
              corporateTravel={corporateTravel}
              onError={() =>
                trackEvent({
                  eventName: "approval_reason_char_limit_error",
                  properties: {
                    funnel: "flights",
                  },
                })
              }
            />
            <Box p="16px 16px 50px">
              <ApprovalBanner
                isApprovalRequired={
                  policies?.settings && policies.settings.isApprovalRequired
                }
              />
            </Box>
          </>
        )}
        {isTripPurposeXpEnabled && (
          isExpenseManagementExperiment ? (
            <TripDescription
              setTripDescription={setTripDescription}
              isEMEligible={isEMEligible}
            />
          ) : (
            <TripPurposePanel setTripPurpose={setTripPurpose} isMobile />
          )
        )}
        <FlightBookMobileButton
          hasContactInfo={!!contactInfo}
          openContactInfo={() =>
            setContactInfoStep(ContactInfoStep.ContactInfoForm)
          }
          isBookingValid={isBookingValid}
          onConfirmAndBook={onBookFlight}
          // TODO: simplify/trim FlightBookMobileButton logic
          showPaymentStep
          onApplyRewards={() => {}}
        />
      </Box>
      <MobilePaymentCardPopover
        openPaymentCard={openPaymentCard}
        disabled={!isBookingValid}
        onClose={() => setOpenPaymentCard(false)}
        onConfirm={() => {
          incrementCheckoutStep();
          setOpenPaymentCard(false);
        }}
        onGoBack={() => {
          if (checkoutStep === MobileFlightBookWorkflowStep.RewardsAndPayment) {
            handleGoBack();
          }
        }}
        mobileHeaderElement={renderPriceBreakdownDropdown()}
        isInPolicy={isInPolicyCheckout}
      />
      <LoadingPopup
        classes={["mobile-price-quote-loading-popup"]}
        open={isWaitingPriceQuote || seatMapLoading}
        message={
          isWaitingValidation &&
          checkoutStep ===
            MobileFlightBookWorkflowStep.PricingAndPassengerValidation
            ? PRICE_QUOTE_PASSENGER_VALIDATION_MESSAGE
            : PRICE_QUOTE_MESSAGE
        }
        indicator={B2BSpinner}
        indicatorSize="small"
        verticalAlignment="center"
        fullScreen
      />
      {openVIVariantModal && openVIVariantModal !== "reminder" && (
        <VirtualInterliningModal
          isMobile
          variant={openVIVariantModal}
          fareDetails={tripDetails.fareDetails}
          airports={airports}
          isOpen
          onClose={() => setOpenVIVariantModal(false)}
        />
      )}
      {openMultipleAirlinesFares && (
        <MultipleAirlinesFareModal
          isOpen={openMultipleAirlinesFares}
          tripDetails={tripDetails}
          airports={airports}
          onClose={() => setOpenMultipleAirlinesFares(false)}
        />
      )}
    </>
  );
};

interface IMobilePaymentCardPopoverProps {
  openPaymentCard: boolean;
  disabled?: boolean;
  onClose: () => void;
  onConfirm: () => void;
  onGoBack: () => void;
  mobileHeaderElement?: JSX.Element;
  isInPolicy: boolean;
}

const MobilePaymentCardPopover = (props: IMobilePaymentCardPopoverProps) => {
  const {
    openPaymentCard,
    disabled = true,
    onClose,
    onConfirm,
    onGoBack,
    mobileHeaderElement,
    isInPolicy,
  } = props;

  return (
    <MobilePopoverCard
      open={openPaymentCard}
      className={clsx("flight-payment-card-popup", "b2b")}
      fullScreen
      onClose={onClose}
      topLeftButton={
        <BackButton
          className="flight-payment-card-popup-back-button"
          onClick={onGoBack}
        />
      }
      headerElement={mobileHeaderElement}
    >
      <PaymentCard />
      {!disabled && (
        <MobileFloatingButton
          className="flight-book-review-trip-button"
          onClick={onConfirm}
          wrapperClassName="b2b"
          dataTestId="payment-method-continue-button"
        >
          {isInPolicy ? REVIEW_MY_TRIP_TEXT : CONTINUE}
        </MobileFloatingButton>
      )}
    </MobilePopoverCard>
  );
};
